import Destination from "../components/Destination";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import Trip from "../components/Trip";

function Home() {
  return (
    <>
     <Navbar/>
      <Hero 
       cName="hero"
       heroImg="https://images.unsplash.com/photo-1499591934245-40b55745b905?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dHJhdmVsbGluZ3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=1000&q=60"
       title="Your Journey Your Story"
       text="Choose Your Favorite Destinations"
       buttonText="Travel Plan"
       url="/"
       btnClass="show"
      
      />
      <Destination/>
      <Trip/>
      <Footer/>
    </>
  );
}

export default Home;
